var map = {
	"./kg": [
		451,
		3
	],
	"./kg.js": [
		451,
		3
	],
	"./ru": [
		452,
		4
	],
	"./ru.js": [
		452,
		4
	],
	"./translation.service": [
		448,
		5
	],
	"./translation.service.js": [
		448,
		5
	],
	"./translation.types": [
		446,
		6
	],
	"./translation.types.js": [
		446,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 536;
module.exports = webpackAsyncContext;